export const version = '0.45.9'
export const name = 'libp2p'
